import { useQuery } from 'react-query'
import { fetchCreatePaymentIntent } from '../utilities/api'

export const rootPaymentIntentQueryKey = 'paymentIntent'

export const useCreatePaymentIntent = (params: {
  checkGuid: string
  orderGuid: string
  restaurantGuid: string
}) => {
  return useQuery({
    queryKey: [
      rootPaymentIntentQueryKey,
      {
        checkId: params.checkGuid,
        orderId: params.orderGuid,
        restaurantId: params.restaurantGuid
      }
    ],
    async queryFn() {
      return fetchCreatePaymentIntent({
        checkId: params.checkGuid,
        orderId: params.orderGuid,
        restaurantId: params.restaurantGuid
      })
    },
    staleTime: Infinity,
    cacheTime: Infinity
  })
}
